<app-uni-dialog [parent]="this" [contentTemplate]="contentTemplate"
  [footerTemplate]="footerTemplate"></app-uni-dialog>

<ng-template #contentTemplate>

  <div class="flex flex-row gap-3 mt-3">
    <uni-field label="Purchase order Instructions" class="w-11/12" >
      <textarea rows="12" cols="80" 
        [(ngModel)]="poHeader.instructions"></textarea>
    </uni-field>
  </div>

</ng-template>

<ng-template #footerTemplate>
  <div class="flex flex-row gap-2">
    <button [disabled]="poHeader.entityAspect.entityState.isUnchanged()" (click)="save()"
      pButton type="button" class="p-button-raised">
      Save
    </button>
    <button (click)="cancel()" pButton type="button" class="p-button-raised">
      Cancel
    </button>
  </div>
</ng-template>